import CitySEOHead from "@/components/feature/CitySEOHead";
import ARHeroSection from "./components/HeroSection";
import ARCitiesDirectory from "./components/CitiesDirectory";
import ARStateResources from "./components/StateResources";
import ARFAQSection, { faqs } from "./components/FAQSection";
import ARFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const arkansasFaqs = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const arkansasServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ArkansasPage() {
  return (
    <>
      <CitySEOHead
        city="Arkansas"
        state="Arkansas"
        stateAbbr="AR"
        route="/states/arkansas"
        title="Arkansas Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Arkansas — Little Rock, Fayetteville, Fort Smith, Springdale, Jonesboro, and Bentonville. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Arkansas, United States"
        geoPosition="35.2010;-91.8318"
        faqs={arkansasFaqs}
        servicesSchema={arkansasServices}
      />
      <div className="font-sans">
        <ARHeroSection />
        <ARCitiesDirectory />
        <ARStateResources />
        <ARFAQSection />
        <SEOCrossLinks state="AR" />
        <ARFinalCTA />
      </div>
    </>
  );
}